export default {"src":"/_next/static/media/envelope.74431d23.svg","height":513,"width":513};